import React from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import dataBlockStyles from '../../../stylesheets/management_site/dataBlock.module.scss';

const EditFieldButton = () => {
  return (
    <button
      className="mdc-button mdc-button--dense mdc-button-icon mdc-button-row pm-text-color--blue1 pm-display"
      data-mdc-auto-init="MDCRipple"
      data-test-class="edit-data-block-button"
    >
      <EditOutlinedIcon className={dataBlockStyles.editIcon} />
    </button>
  );
};

export default EditFieldButton;
